import { render, staticRenderFns } from "./InputFullName.vue?vue&type=template&id=23b2e059&"
import script from "./InputFullName.vue?vue&type=script&lang=ts&"
export * from "./InputFullName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports